/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */

export const constanceMode = {
  MAP: "map",
  TRAJET: "trajet",
  COMMAND: "command",
  PARAMETRE: "param",
};

export const tabColor = [
  "#B28562",
  "#674978",
  "#AA5F61",
  "#39A299",
  "#D61E3D",
  "#40127E",
  "#AF1DA9",
  "#CDE798",
  "#97B30E",
  "#93935C",
  "#9E1B2C",
  "#8B2AB3",
  "#9DCC65",
  "#CB816B",
  "#177FCC",
  "#76FFD1",
  "#62DC1B",
  "#A5F945",
  "#138214",
  "#F6B7D9",
  "#D8E04A",
  "#E06010",
  "#996E90",
  "#B6F5CC",
  "#062BC0",
  "#A98333",
  "#867DE0",
  "#343E97",
  "#B98B3D",
  "#75AC1B",
  "#E8218C",
  "#C72306",
  "#5DAB96",
  "#F34241",
  "#F03395",
  "#2D893F",
  "#292BE7",
  "#4E4F32",
  "#2200F7",
  "#88DC6A",
  "#1C8F85",
  "#619BEB",
  "#87FEC8",
  "#6E7D02",
  "#F57DEF",
  "#87C6E4",
  "#46C9C7",
  "#1BA2D8",
  "#1E9789",
  "#7B8B33",
  "#2B0BDA",
  "#BB14D6",
  "#D9DC80",
  "#9ABA5E",
  "#3D5AE3",
  "#45702F",
  "#69A2F0",
  "#1545A5",
  "#11D10F",
  "#E6B8D7",
  "#AA8DFA",
  "#E77E1A",
  "#1ED9F2",
  "#812098",
  "#2E5465",
  "#0D43D8",
  "#3A56D8",
  "#AB6AF6",
  "#D12B29",
  "#921246",
  "#64DF02",
  "#A0232D",
  "#E1F4CE",
  "#32C917",
  "#6A4625",
  "#82C02D",
  "#2C97DE",
  "#3B72DC",
  "#F8EF9E",
  "#0A075C",
  "#3E8C26",
  "#A1F4F6",
  "#96D10A",
  "#EBC8B5",
  "#330DC8",
  "#CCB9A3",
  "#181AE0",
  "#5085FF",
  "#70FCF6",
  "#F35774",
  "#A33129",
  "#6FECD6",
  "#49A7E8",
  "#7544FA",
  "#384C53",
  "#B5A80C",
  "#7C628C",
  "#ACBE7D",
  "#726208",
  "#B3E849",
  "#D7B1ED",
  "#4DF35F",
  "#C2A733",
  "#BC0A08",
  "#F80A4A",
  "#E954CD",
  "#47E7AD",
  "#6CAC67",
  "#13374C",
  "#86B662",
  "#18BDC2",
  "#429971",
  "#401FDB",
  "#FAED0D",
  "#FF59AA",
  "#B0A4C5",
  "#C58437",
  "#0DE5C9",
  "#6F5288",
  "#39FE3E",
  "#F680C4",
  "#0F9659",
  "#C3EA33",
  "#A932E8",
  "#F1A498",
  "#7FCC54",
  "#26C687",
  "#FE51DF",
  "#7E2521",
  "#A65C42",
  "#5B0AE4",
  "#E7D4B0",
  "#F31C84",
  "#49C936",
  "#6FFF83",
  "#33FDD9",
  "#0310CC",
  "#F0E84E",
  "#062063",
  "#24FE46",
  "#DC5DD5",
  "#96782B",
  "#DD921E",
  "#41155F",
  "#013C89",
  "#BCEDA9",
  "#B49E57",
  "#8D1B6A",
  "#8B8C67",
  "#74E366",
  "#FA348C",
  "#97E003",
  "#81E5C7",
  "#30EEB8",
  "#C371ED",
  "#29978E",
  "#70552F",
  "#451D0B",
  "#87EA3B",
  "#FFD428",
  "#F8DEE3",
  "#1FCC6E",
  "#F91527",
  "#2CFA25",
  "#2A5972",
];
